<script setup lang="ts">
import { PropType } from "vue";

const props = defineProps({
  modelValue: {
    type: [String, Boolean],
  },
  tabs: {
    type: Array as PropType<Tabs>,
    required: true,
  },
  tabWidth: {
    type: String,
  },
  size: {
    type: String as PropType<"xs" | "sm">,
    default: "sm",
  },
});

const emit = defineEmits(["update:modelValue"]);

const setModelValue = (value: string | boolean) => {
  emit("update:modelValue", value);
};
</script>

<template>
  <div
    class="inline-flex w-fit max-w-full rounded border border-medium-tint overflow-hidden"
    :class="{
      'text-body-2': size == 'xs',
      'text-body-1': size == 'sm',
    }"
  >
    <div
      v-for="tab in tabs"
      :key="tab.key.toString()"
      class="p-1 px-2 border-r-medium-tint border-r last:border-r-0 cursor-pointer text-center min-w-max"
      :class="
        modelValue == tab.key
          ? 'bg-primary/20 hover:bg-primary/10'
          : 'hover:bg-light-default'
      "
      :style="{
        width: tabWidth,
      }"
      @click="setModelValue(tab.key)"
    >
      {{ tab.label }}
    </div>
  </div>
</template>

<style scoped></style>
